import Vue from 'vue';
import dot from 'dot-object';

export default {
  methods: {
    // Will return first error for specified field, esle default value or undefined
    fErr(path, def = undefined) {
      const err = dot.pick(path, this.errorMsg) || def;
      return Array.isArray(err) && err.length > 0 ? err[0] : err;
    },
  }
};
